// Navigation routes and view types
export enum NavigationRoute {
  DASHBOARD = 'dashboard',
  ANALYTICS = 'analytics',
  MAP = 'map',
  POLYGONS = 'polygons',
  USER_MANAGEMENT = 'user_management',
  KNOWLEDGE_BASE = 'knowledge_base'
}

// Chart types for NEE visualization
export enum ChartType {
  ANNUAL = 'annual',
  MONTHLY = 'monthly'
}

// NEE data display modes
export enum NEEDisplayMode {
  TOTAL = 'total',
  INTENSITY = 'intensity'
}

// Polygon grouping options
export enum GroupingOption {
  NONE = 'none',
  COUNTRY = 'country',
  NAME = 'name',
  LAND_COVER = 'land_cover',
  TAGS = 'tags'
}

// Sorting options
export enum SortingOption {
  NONE = 'none',
  NAME_ASC = 'nameAsc',
  NAME_DESC = 'nameDesc',
  AREA_ASC = 'areaAsc',
  AREA_DESC = 'areaDesc',
  NEE_ASC = 'neeAsc',
  NEE_DESC = 'neeDesc'
}

// Data source types
export enum DataSource {
  FLUXNET2015 = 'FLUXNET2015',
  AMERIFLUX = 'AmeriFlux',
  AGERA5 = 'AgERA5',
  LANDSAT = 'Landsat'
}

// Historical Baseline Tool enums
export enum NEEView {
  COMPARISON = 'comparison',
  DIFFERENCE = 'difference',
}

export enum Unit {
  TCO2 = 'tCO2',
  KTCO2 = 'ktCO2',
}
